import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js';
import {USE_LEGACY_TWEEN_GROUP} from 'components/customer/Preview3DCommon/lib/tween';
import {
    OperationGroup,
    PreviewFormValues,
} from 'components/customer/Preview3D/types';
import {TemplateVariable} from 'components/customer/Preview3D/usePreview3DData';
import {AnimationHandler} from 'components/customer/Preview3D/animation/entity/AnimationHandler';
import {RoomPlannerProduct} from 'components/customer/RoomPlanner/types';
import {getPartAttributes} from 'components/customer/RoomPlanner/helpers/getProductAttributes';

export const toggleDrawerHandler = (
    mesh: THREE.Group<THREE.Object3DEventMap>,
    operationGroup: OperationGroup,
    variables: TemplateVariable,
    values: RoomPlannerProduct | PreviewFormValues,
    drawerIndex = 1
): AnimationHandler => {
    let depth = mesh.position.y;
    const {isInnerDrawer, isBinDrawer, isBinInnerDrawer, isDoorPullout} =
        getPartAttributes(operationGroup, variables, values);
    const shouldDelay = isInnerDrawer;
    if (isInnerDrawer) depth += 10;

    let depthOffsetCalculation = Math.min(50 * Math.abs(drawerIndex + 1), 200);
    if (isDoorPullout) depthOffsetCalculation = 250;
    if (isBinDrawer) depthOffsetCalculation = 400;
    if (isBinInnerDrawer) depthOffsetCalculation = 50;

    const closePosition = {
        y: depth,
    };

    const openPosition = {
        y: depth - depthOffsetCalculation,
    };

    // position defaults to closed
    const currentPosition = {
        y: closePosition.y,
    };

    const openDrawer = (animationSpeed = 600, delay = false) =>
        new Promise<void>((resolve) => {
            const tween = new TWEEN.Tween(
                currentPosition,
                USE_LEGACY_TWEEN_GROUP
            )
                .to(openPosition, animationSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => {
                    resolve();
                })
                .delay(shouldDelay && delay ? 400 : 0)
                .onUpdate(() => {
                    mesh.position.y = currentPosition.y;
                });

            tween.start();
        });

    const closeTween = (animationSpeed = 600) =>
        new Promise<void>((resolve) => {
            const tween = new TWEEN.Tween(
                currentPosition,
                USE_LEGACY_TWEEN_GROUP
            )
                .to(closePosition, animationSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => {
                    resolve();
                })
                .onUpdate(() => {
                    mesh.position.y = currentPosition.y;
                });

            tween.start();
        });

    return {
        open: [openDrawer],
        close: [closeTween],
    };
};
